import CryptoJS from 'crypto-js';

const secretKeyString = (import.meta as any).env?.VITE_ENCRYPTION_KEY as string | undefined;

function getSecretKey() {
  if (!secretKeyString) {
    throw new Error('VITE_ENCRYPTION_KEY is not set');
  }
  return CryptoJS.enc.Utf8.parse(secretKeyString);
}

/** True when client-side API body encryption is configured (client requirement). */
export function isClientApiEncryptionConfigured(): boolean {
  const key = (import.meta as any).env?.VITE_ENCRYPTION_KEY;
  return typeof key === 'string' && key.trim().length > 0;
}

export const encryptData = (data: unknown) => {
  const iv = CryptoJS.lib.WordArray.random(16);
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), getSecretKey(), { iv }).toString();
  return `${iv.toString(CryptoJS.enc.Hex)}:${ciphertext}`;
};

export const decryptData = (ciphertext: string) => {
  const [ivHex, encryptedText] = ciphertext.split(':');
  const iv = CryptoJS.enc.Hex.parse(ivHex);
  const bytes = CryptoJS.AES.decrypt(encryptedText, getSecretKey(), { iv });
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

export const decryptValue = (ciphertext: string): string => {
  const [ivHex, encryptedText] = ciphertext.split(':');
  const iv = CryptoJS.enc.Hex.parse(ivHex);
  const bytes = CryptoJS.AES.decrypt(encryptedText, getSecretKey(), { iv });
  return bytes.toString(CryptoJS.enc.Utf8);
};

/** Legacy iv:ciphertext or gcm: payloads from API wrapper. */
export function looksLikeEncryptedApiPayload(value: unknown): value is string {
  if (typeof value !== 'string' || value.length < 40) return false;
  if (value.startsWith('gcm:')) return true;
  return /^[0-9a-f]{32}:[A-Za-z0-9+/=_-]+$/i.test(value);
}
